import { UsersRound } from "lucide-react";
import {
  ProjectContextParamsSchema,
  defaultProjectContextParams,
  type ProjectContextParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { ProjectContextWidget } from "./Component.js";

export const projectContextDef: SqlWidgetDef<ProjectContextParams> = {
  kind: "projectContext",
  label: "VSM Project Context",
  modes: [],
  singleton: true,
  defaultSize: { w: 620, h: 360 },
  defaultParams: defaultProjectContextParams,
  Component: ProjectContextWidget,
  storage: "sql",
  schema: ProjectContextParamsSchema,
  accent: "purple",
  icon: UsersRound,
  subtitle: "Value stream roles and expected outcomes",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 2, width: 620, height: 360 },
};

registerWidget(projectContextDef);
